import React, { useState, useEffect, useContext } from 'react';
import axios from 'axios';
import './profile.css';
import { Link } from 'react-router-dom';
import successIcon from '../../../Constant/Icons/success-Svg.svg';
import failIcon from '../../../Constant/Icons/error_icon.svg';
import { serverUrl } from '../../../Constant/Static/config';
import { AuthContext } from '../../../Auth/AuthContext';
import Loader from '../../../Constant/Custom/Loader';

function Profile({ close }) {

    const { auth } = useContext(AuthContext);
    const [reciptBtnClicked, setReciptBtnClicked] = useState({})
    const [loading, setLoading] = useState(true);
    // const [photoPreview, setPhotoPreview] = useState('');
    // const [signaturePreview, setSignaturePreview] = useState('');
    const [csrfToken, setCsrfToken] = useState('');

    const [activeMenu, setActiveMenu] = useState('Profile');
    const [appDetails, setAppDetails] = useState(null);
    const [transactions, setTransactions] = useState(null);

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true  // Ensure cookies are sent
                });
                setCsrfToken(response.data.csrfToken);  // Set CSRF token
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            if (csrfToken) {
                try {
                    const userDataFromLocalStorage = auth.user;
                    if (userDataFromLocalStorage) {
                        const response = await axios.post(
                            `${serverUrl}/api/user/profile`,
                            {
                                appno: userDataFromLocalStorage.appno,
                                email: userDataFromLocalStorage.email,
                                mobile: userDataFromLocalStorage.mobile
                            },
                            {
                                headers: {
                                    'CSRF-Token': csrfToken
                                },
                                withCredentials: true
                            }
                        );
                        if (response.status === 200) {
                            // console.log(response.data);
                            setAppDetails({
                                appno: response.data.appno, userName: response.data.userName, email: response.data.email, mobile: response.data.mobile, dob: response.data.dob, appimage: response.data.applicant_image, appsign: response.data.applicant_sign
                            });
                            setTransactions(response.data.paymentDetails)
                            setLoading(false);
                        } else {
                            // console.log('Error');
                        }
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);




    const handleDownload = async (tid, index) => {
        // console.log("index", index);

        const userDataFromLocalStorage = auth.user;
        try {
            if (userDataFromLocalStorage) {
                const btnClicked = { ...reciptBtnClicked, [index]: true }
                setReciptBtnClicked(btnClicked)
                const response = await axios.post(
                    `${serverUrl}/api/user/doc/generate-receipt`,
                    {
                        transactionId: tid,
                        appno: userDataFromLocalStorage.appno,
                        email: userDataFromLocalStorage.email,
                        mobile: userDataFromLocalStorage.mobile
                    },
                    {
                        responseType: 'arraybuffer'
                    }
                );
                // console.log("Received PDF response", response);


                const blob = new Blob([response.data], { type: 'application/pdf' });
                const url = window.URL.createObjectURL(blob);

                const a = document.createElement('a');
                a.href = url;
                a.download = `Payment-Receipt-${userDataFromLocalStorage.appno}.pdf`;
                document.body.appendChild(a);
                a.click();
                a.remove();

                window.URL.revokeObjectURL(url);
            }

        }
        catch (err) {
            // console.log("ks");

        }
        finally {
            const pdfDownloaded = { ...reciptBtnClicked, [index]: false }
            setReciptBtnClicked(pdfDownloaded)
        }


    }

    if (loading) {
        return <Loader />;
    }


    return (
        <div className="modal-overlay">
            <div className="modal-container">
                <div className='profile-title'>
                    Applicant Profile
                    <button onClick={close} className="close-button" >×</button>
                </div>
                <div className='profile-content'>
                    <div className='profile-nav'>
                        <ul className='profile-nav-list'>
                            <li
                                className={activeMenu === 'Profile' ? 'profile-tab-active' : null}
                                onClick={() => setActiveMenu('Profile')}
                            >
                                Profile
                            </li>
                            <li
                                className={activeMenu === 'Transactions' ? 'profile-tab-active' : null}
                                onClick={() => setActiveMenu('Transactions')}
                            >
                                Transactions
                            </li>
                        </ul>
                    </div>
                    {activeMenu === 'Profile' && (
                        <div className='profile-details'>
                            {appDetails ? (
                                <>
                                    <div>
                                        <div className='profile-data-container'>
                                            <div className='data-label-container'>
                                                <div className='data-label'>Name of the Applicant</div>
                                            </div>
                                            <div className='data-value'>{appDetails.userName}</div>
                                        </div>
                                        <div className='profile-data-container'>
                                            <div className='data-label-container'>
                                                <div className='data-label'>Email ID</div>
                                            </div>
                                            <div className='data-value'>{appDetails.email}</div>
                                        </div>
                                        <div className='profile-data-container'>
                                            <div className='data-label-container'>
                                                <div className='data-label'>Mobile Number</div>
                                            </div>
                                            <div className='data-value'>{appDetails.mobile}</div>
                                        </div>
                                        <div className='profile-data-container'>
                                            <div className='data-label-container'>
                                                <div className='data-label'>Date of Birth</div>
                                            </div>
                                            <div className='data-value'>{appDetails.dob}</div>
                                        </div>
                                        <div className='profile-data-container'>
                                            <div className='data-label-container'>
                                                <div className='data-label'>Application Number</div>
                                            </div>
                                            <div className='data-value'>{appDetails.appno}</div>
                                        </div>
                                        <div className='profile-data-container'>
                                            {/* <div className='password-change'>Change Password</div> */}
                                            <Link className='password-change' to="/forgot-password">Change Password</Link>

                                        </div>
                                    </div>
                                    <div className='profile_image_section'>

                                        {(appDetails.appimage && appDetails.appsign) && (<><div>
                                            <img src={appDetails.appimage} height="90px" width="90px"></img></div>
                                            <div>
                                                <img src={appDetails.appsign} height="50px" width="90px"></img>
                                            </div></>)}


                                    </div>


                                </>
                            ) : (
                                <p>Loading Applicant details...</p>
                            )}
                        </div>

                    )}
                    {activeMenu === 'Transactions' && (
                        <div className='transaction-details'>
                            {appDetails ? (
                                <>
                                    <div className='info-body'>
                                        <span className='info-message'>Sometimes payment might take upto 20 minutes to reflect in our system, kindly request you to be patience. If money is deducted from your account but transaction status is still in progress, refresh payment status after 20 minutes by clicking on refresh button from action column, even after retry if status shows in progress please wait for a day and retry the status again, as in progress indicates that we haven't received payment status from payment gateway. If payment status shows fails then make next payment. </span>
                                    </div>
                                    <div className="table-container">
                                        <table className="transaction-table">
                                            <thead>
                                                <tr>
                                                    <th>S.No</th>
                                                    <th>Gateway</th>
                                                    <th>Transaction ID</th>
                                                    <th>Status</th>
                                                    <th>Date</th>
                                                    <th>Action</th>
                                                    <th>Download Receipt</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {transactions.map((transaction, index) => (
                                                    <tr key={index}>
                                                        <td>{index + 1}</td>
                                                        <td>{transaction.Gateway === null ? '-' : transaction.Gateway}</td>
                                                        <td>{transaction.TransID === null ? '-' : transaction.TransID}</td>
                                                        <td className={transaction.Status === 'Success' ? 'positive' : 'negative'}>{transaction.Status}</td>
                                                        <td>{transaction.TransDate === null ? '-' : transaction.TransDate}</td>
                                                        <td>{transaction.Status === 'Success' ? (
                                                            <img src={successIcon} width={20} height={20} alt='Success' />
                                                        ) : (
                                                            <img src={failIcon} width={20} height={20} alt='Failed' />
                                                        )}</td>
                                                        <td> {reciptBtnClicked[index] ? <p style={{ fontSize: '10px' }}>Downloading.. .</p> : transaction.TransID !== null ? <button style={{ cursor: 'pointer', border: 'none', padding: '8px', borderRadius: '5px' }} onClick={() => { handleDownload(transaction.TransID, index) }} className="button-primary">Download</button> : <button style={{ cursor: 'not-allowed' }} disabled>Download</button>} </td>

                                                    </tr>
                                                ))}
                                            </tbody>
                                        </table>
                                    </div>
                                    <div style={{ fontSize: '2vh' }}>Please contact us at <span style={{ color: 'red' }}> tnleaacgcet2025@gmail.com</span> if you see any issues with payment with Application Number, Transaction Id and any other details that can help us to fix your payment.</div>
                                </>
                            ) : (
                                <p>Loading Applicant details...</p>
                            )}
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default Profile;